/**
 * Formato de dinero y cantidades.
 *
 * El dinero viaja como texto desde el servidor a propósito (los DECIMAL de
 * MySQL se leen sin convertir) para no perder centavos en el camino. Aquí se
 * convierte sólo para mostrarlo, nunca para calcular con él.
 */
const pesos = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 2,
});

export function dinero(valor: string | number | null | undefined): string {
  const n = Number(valor ?? 0);
  return Number.isFinite(n) ? pesos.format(n) : pesos.format(0);
}

/** Cantidades: sin decimales cuando son piezas, con ellos cuando es granel. */
export function cantidad(valor: string | number | null | undefined): string {
  const n = Number(valor ?? 0);
  if (!Number.isFinite(n)) return '0';
  return Number.isInteger(n) ? String(n) : n.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
}

export const ETIQUETA_ESTADO: Record<string, string> = {
  borrador: 'Borrador',
  publicado: 'A la venta',
  agotado: 'Agotado',
  archivado: 'Archivado',
};

/** El color dice el estado antes de que se lea la palabra. */
export const CLASE_ESTADO: Record<string, string> = {
  borrador: 'bg-salvia/15 text-salvia',
  publicado: 'bg-nopal-claro text-nopal-oscuro',
  agotado: 'bg-miel-claro text-miel-oscuro',
  archivado: 'bg-barro-claro text-barro-oscuro',
};
